import { SMART_CONTRACT_PLUGIN_CATEGORIES } from "@/components/SmartContractDesigner/pluginCategories";
import { PLUGIN_CATEGORIES } from "./plugin-categories";

export const DEFAULT_PLUGINS = (function () {
    const toReturn = [];
    PLUGIN_CATEGORIES.forEach(cat => {
        toReturn.push(...cat.plugins);
    });
    return toReturn;
}());

export const SMART_CONTRACT_PLUGINS = (function () {
    const toReturn = [];
    SMART_CONTRACT_PLUGIN_CATEGORIES.forEach(cat => {
        toReturn.push(...cat.plugins);
    });
    return toReturn;
}());
